import React, { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';
import { Table, Breadcrumb } from 'react-bootstrap';
import { AiOutlinePlusCircle } from 'react-icons/ai';

import ServiceService from 'Services/ServiceService';

const Apps = () => {
    const [services, setServices] = useState([]);

    useEffect(() => {
        ServiceService.getServices()
            .then((result) => {
                if (result.status === 200) {
                    setServices(result.data);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }, []);

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item active>Services</Breadcrumb.Item>
            </Breadcrumb>
            <div className="d-flex justify-content-between align-items-center py-2">
                <h2>Services</h2>
                <Link to="/admin/service/create">
                    <button className="btn btn-outline-primary btn-sm">
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                </Link>
            </div>

            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>Service</th>
                        <th>CodeInterne</th>
                        <th>Departement</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {services.length ? (
                        services.map((service, key) => {
                            return (
                                <tr key={key}>
                                    <td>{service.nom}</td>
                                    <td>{service.codeInterne}</td>
                                    <td>{service.departement.nom}</td>
                                    <td>{service.projet ? service.projet.name : '-'}</td>
                                    <td>
                                        <Link to={`/admin/service/edit/${service.serviceId}`}>
                                            <img
                                                src="/images/edit.svg"
                                                alt=""
                                                style={{
                                                    height: '15pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                    <td>
                                        <Link to={`/admin/service/delete/${service.serviceId}`}>
                                            <img
                                                src="/images/delete.svg"
                                                alt=""
                                                style={{
                                                    height: '18pt',
                                                }}
                                            />
                                        </Link>
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td colSpan="6">no data</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </>
    );
};

export default Apps;
